import { Typography } from 'antd';
import { useEffect, useState } from 'react';

// moment тянул в бандл ~60 kB ради одного форматирования HH:mm:ss.
const formatter = new Intl.DateTimeFormat(undefined, {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

const getNow = () => formatter.format(new Date());

const STYLE = {
  fontSize: '24px',
  lineHeight: '24px',
  width: '110px',
  textAlign: 'center',
} as const;

const Clock = () => {
  const [time, setTime] = useState(getNow);

  useEffect(() => {
    // Раз в секунду вместо 500 мс: значение всё равно меняется не чаще.
    // Строка та же => setState с тем же примитивом React отбрасывает без рендера.
    const interval = setInterval(() => setTime(getNow()), 1000);
    return () => clearInterval(interval);
  }, []);

  return <Typography.Text style={STYLE}>{time}</Typography.Text>;
};

export default Clock;
